// extracted by mini-css-extract-plugin
module.exports = {"listElement":"breadcrumb_listElement__pWRFu","active":"breadcrumb_active__pQJ2e"};